var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-skeleton-img'),_c('b-card-body',[_c('b-skeleton',{attrs:{"height":"10%"}}),_c('b-skeleton',{attrs:{"height":"10%"}}),_c('b-skeleton',{attrs:{"height":"10%","width":"40%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }